import english from './english';

// Default to English for now
// In the future, we could add other languages and select based on user preferences
export default english;